const ONE_SECOND = 1000;
const ONE_MINUTE = 60000;
const ONE_HOUR = 60 * ONE_MINUTE;
const ONE_DAY = 24 * ONE_HOUR;
const ONE_YEAR = 365 * ONE_DAY;
const DATE_TIME_LOCALE = 'en-US';
export { DATE_TIME_LOCALE, ONE_DAY, ONE_HOUR, ONE_MINUTE, ONE_SECOND, ONE_YEAR };

//# sourceMappingURL=constants.js.map